import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, take, takeUntil, tap} from "rxjs/operators";
import {interval, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {CommissionMarginReportService} from "../../../../shared/services/commission-margin-report.service";
import {CommissionMarginReport} from "../../../../shared/interface/commission-margin-report";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import moment from "moment/moment";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {Sort} from "@angular/material/sort";

@Component({
  selector: 'app-commission-margin-report-list',
  templateUrl: './commission-margin-report-list.component.html',
  styleUrls: ['./commission-margin-report-list.component.scss']
})
export class CommissionMarginReportListComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() embeddedView = false;

  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  totalData = 0;
  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;
  sortBy = 'billingMonth';
  sortOrder = 'desc';
  displayedColumns: string[] = ['billingMonth', 'requestedAt', 'parameters', 'action'];
  items: CommissionMarginReport[] = [];
  commissionMarginReportObject: CommissionMarginReport[] = [];
  billingMonthControl: FormControl;
  actionForm: FormGroup;
  disabledGenerateMargin = true;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private router: Router,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private marginService: CommissionMarginReportService,
    private fb: FormBuilder,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.loadMargin();
    this.parseFilters();

    const date = moment();
    date.startOf('month');
    date.subtract(1, 'month');
    this.billingMonthControl = fb.control(date, [Validators.required]);

    this.actionForm = fb.group({
      billingMonth: this.billingMonthControl,
    });
  }


  loadMargin(): void {
    this.marginService.marginListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<CommissionMarginReport>) => {
          this.userPermissions.pipe().subscribe((user) => {
            this.commissionMarginReportObject = e.items;
            if (user.settlement?.margin === true) {
              if (!e.data){
                this.disabledGenerateMargin = false;
              } else {
                this.disabledGenerateMargin = true;
              }
            }
          });
          this.totalData = e.pagination.total;
        })
      )
      .subscribe();
  }
  ngOnInit(): void {
      interval(2000)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => {
        if (this.paginator.pageIndex === 0) {
          this.loadMargin();
          this.loadListData();
        }
      });
    this.billingMonthControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((billingMonth) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: this.paginator.pageIndex,
          pageSize: this.paginator.pageSize,
          billingMonth,
          ...this.initialFilters,
        })]);
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.userPermissions.pipe().subscribe((user) => {
      if (user.settlement.margin){
      }
    });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        billingMonth: this.billingMonthControl.value,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;

        if (state.params?.billingMonth) {
          this.billingMonthControl.setValue(moment(state.params.billingMonth));
        }

        this.loadListData();
      })
    ;
  }

  loadListData(): void {
    this.marginService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
      );

  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    // filters.billingMonth = this.billingMonthControl.value.format('YYYY-MM');

    return filters;
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      billingMonth: 'date',
    }, filters);
  }


  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      billingMonth: this.billingMonthControl.value,
      ...this.filtersForm.value,
    })]);
  }

  generateMargin(): void {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.disabledGenerateMargin = true;
        this.loadListData();
        this.marginService.generateMargin(this.actionForm.value)
          .subscribe(() => {
            this.loadListData();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Brak możliwości wygenerowania raportu. Wybrany miesiąc rozliczeniowy nie został zamknięty.', error.status.toString(), {duration: 2000});
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      }
    });
  }
  trackTask(index: number, commissionMarginReports: CommissionMarginReport): string {
    return commissionMarginReports.uuid;
  }

  download(commissionMarginReports: CommissionMarginReport): void {
    this.marginService.downloadFile(commissionMarginReports.uuid);
  }

  delete(commissionMarginReports: CommissionMarginReport): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć raport?'},
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.marginService.deleteJob(commissionMarginReports.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto', '', {duration: 2000});
            // this.loadListData();
          });
      }
    });
  }

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    // if (!this.embeddedView) {
    //   this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
    //     sortBy: $event.active,
    //     sortOrder: $event.direction,
    //     page: this.paginator.pageIndex,
    //     pageSize: this.paginator.pageSize,
    //     ...this.filtersForm.value
    //   })]);
    // } else {
      this.loadListData();
    // }
  }
}
